module.exports = __webpack_public_path__ + "static/media/create-focused.972c76e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/create-focused.svg
// module id = 1234
// module chunks = 0